<script setup lang="ts">
/**
 * 通用提示条。
 * 顾客看不懂错误码，所以这类提示一律用后端已经翻译好的中文（或兜底中文），
 * 并且需要顾客主动点掉 —— 自动消失的提示在触屏上经常被完全错过。
 */
defineProps<{ text: string; type?: 'error' | 'info' }>();
const emit = defineEmits<{ (e: 'close'): void }>();
</script>

<template>
  <div class="overlay" @click.self="emit('close')">
    <div class="dialog notice" :class="{ 'notice--error': type !== 'info' }">
      <div class="notice__icon">{{ type === 'info' ? 'ℹ️' : '⚠️' }}</div>
      <div class="dialog__title">{{ type === 'info' ? '提示' : '这一步没成功' }}</div>
      <div class="notice__text">{{ text }}</div>
      <button class="btn btn--primary btn--block" @click="emit('close')">知道了</button>
    </div>
  </div>
</template>

<style scoped>
.notice {
  width: min(620px, 100%);
  text-align: center;
  align-items: center;
}

.notice__icon {
  font-size: 54px;
  line-height: 1;
}

.notice__text {
  font-size: 22px;
  line-height: 1.5;
}
</style>
